export default __webpack_public_path__ + "img/610704470aae5cf96233e2f467b60b91.svg";